
import {View} from 'backbone';
import template from 'common-views/common-import.ejs';
import constants from 'Constants.js';
import $ from 'jquery';

class CommonImportModalView extends View {
    initialize(opts){
        super.initialize(opts);
        $('body').append(this.$el);

        this.allowedMimeTypes = {
            'text/plain': true,
            'text/csv': true,
            'application/vnd.ms-excel': true
        };
        //PF-5928 As defined in help documentation only csv and txt are allowed
        this.allowedExtensions = {
            'csv': true,
            'txt': true
        };
    }

    showImportDialog(ev) {
        $(constants.DIALOG_ID).find("input[type='file']").trigger('click');
    }

    fileIsAllowed(file){

        const name = file.name;
        const lastDot = name.lastIndexOf('.');
        const ext = name.substring(lastDot + 1);
        //PF-5928 Add fail safe in case there is no file type
        return file.type ? this.allowedMimeTypes[file.type] && this.allowedExtensions[ext] : this.allowedExtensions[ext]; 

    }

    importFile() {
        this.file = $(constants.DIALOG_ID).find("input[type='file']")[0].files[0];
        if (this.file && this.file.name) {
            this.model.set('name', this.file.name, {silent: true});
            $(constants.DIALOG_ID).find('input[type=text]').val(this.file.name).focus().blur();
        }
        this.validateFile();

    }


    validateFile(){
        if (!this.file){
            $(constants.DIALOG_ID).find('input[type=text]').val('');
            this.model.set('name', '', {silent: true});
            $('.error_message').text('No file selected, please select a file');
            $('.error_message').removeClass('hide');
            $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
            return;
        } else if(!this.fileIsAllowed(this.file)){
            $(constants.DIALOG_ID).find('input[type=text]').val('');
            this.model.set('name', '', {silent: true});
            $('.error_message').text('Wrong file type, please correct:'  + this.file.name);
            $('.error_message').removeClass('hide');
            $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
            return
        }
        else if(this.model.get('name') === ''){
            $(constants.DIALOG_ID).find('input[type=text]').val('');
            this.model.set('name', '', {silent: true});
            $('.error_message').text('Please enter a file name');
            $('.error_message').removeClass('hide');
            $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
            return;
        }
        $('.error_message').text('');
        $('.error_message').addClass('hide');
        $('.btn-select-item').prop('disabled', false).removeClass('ui-button-disabled').removeClass('ui-state-disabled');
    }

    saveInput(ev){
        this.model.set(ev.currentTarget.name,ev.currentTarget.value,{silent:true});
        this.validateFile();
    }

    render(){
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 'auto',
                width: 500,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Upload',
                        disabled:true,
                        'class':'btn-select-item',
                        click: () => {
                            resolve({file:this.file,name:this.model.get('name'),type:'customlist'});
                            this.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve('Cancel');
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    this.bindEvents();
                },
                close: () => {
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }
    bindEvents(){
        $(constants.DIALOG_ID).find('input[name=importFile]').click(e => this.showImportDialog(e));
        $(constants.DIALOG_ID).find('input[name=file]').change(e => this.importFile(e));
        $(constants.DIALOG_ID).find('input[name=name]').change(e => this.saveInput(e));
        $(constants.DIALOG_ID).find('input[name=name]').blur(e => this.saveInput(e));
    }

    unbindEvents(){
        $(constants.DIALOG_ID).find('input[name=importFile]').unbind();
        $(constants.DIALOG_ID).find('input[name=file]').unbind();
        $(constants.DIALOG_ID).find('input[name=name]').unbind();
    }


    closeModal(){
        $( constants.DIALOG_ID ).dialog("destroy").remove();
    }
}

export default CommonImportModalView;